import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class FileUploadComponent implements OnInit {
  @Input() fileToUpload: File;
  @Input() label: string;
  @Input() innerLabel: string = 'Browse';
  @Input() allowedFileType: string = '.jpg, .jpeg, .png, .pdf';
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() isDisabled: boolean = false;

  //fileToUpload: File = null;
  constructor() {
  }

  ngOnInit() {
    try {
    } catch (ex) {
      throw ex;
    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.onChange.emit(this.fileToUpload);
  }

  uploadFileToActivity() {
    //this.fileUploadService.postFile(this.fileToUpload).subscribe(data => {
    //  // do something, if upload success
    //}, error => {
    //  console.log(error);
    //});
  }
}

